export default __webpack_public_path__ + "static/media/9.215a08c9.svg";